import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import type { FranchiseType } from '../types';
import { apiClient } from '@/_config/lib/axios/api-client';

export const GET_PLACE_FARE = 'GET_PLACE_FARE';

type GetPlaceFareParams = {
  placeId: string;
};

const getPlaceFare = (params: GetPlaceFareParams) => {
  const { placeId } = params;

  return apiClient
    .get<FranchiseType>(`/estabelecimentos/${placeId}/fare`)
    .then(response => response.data)
    .catch(
      handleResponseThrowError('Erro ao buscar tarifa do estabelecimento.'),
    );
};

type GetPlaceFareResponse = Awaited<ReturnType<typeof getPlaceFare>>;

export const useGetPlaceFare = (
  params: GetPlaceFareParams,
  options: Omit<
    UseQueryOptions<
      GetPlaceFareResponse,
      unknown,
      GetPlaceFareResponse,
      (string | GetPlaceFareParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_PLACE_FARE, params],
    queryFn: () => getPlaceFare(params),
    ...options,
  });
};
